<template>
  <div class="bg-white">
    <div class="d-flex justify-content-end h-100 align-items-center">
      <b-button size="sm" :variant="'outline-secondary'" :class="['btn-fixed', 'mr-2', {'disabled':dBack}]" :disabled="dBack" @click="$emit('back')">
        {{ $t('Back') }}
      </b-button>
      <b-button size="sm" :variant="'secondary'" :class="['btn-fixed', 'mr-2', {'disabled':dNext}]" :disabled="dNext" @click="$emit('next')">
        {{ $t('Next') }}
      </b-button>
      <div class="d-inline-block text-center btn-fixed mr-2">
        <b-button
          v-if="globalSave"
          :variant="'primary'"
          size="sm"
          :disabled="dSave"
          :class="['btn-fixed', 'animated-submit', submitClassObject, {'disabled': dSave, 'animate': animateSubmitButton}]"
          @click="listingSaveEvent"
        >
          <span
            v-b-tooltip.hover
            class="d-flex justify-content-center w-100 stretched-link"
            :title="dSave ? $t('You have no changes in this page to save'): ''"
          >{{ $t('Save') }}</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import userDevice from "@/imports/mixins/userDevice";
import submitAnimationHandler from "@/imports/mixins/submitAnimationHandler";

export default {
  name: "ListingButtons",
  mixins: [userDevice, submitAnimationHandler],
  props: [
    'disableSave',
    'savingAnimation',
    'globalSave',
    'busy',
    'next',
    'back',
    'save'
  ],
  computed: {
    dBack: function() {
      return this.busy || !this.back;
    },
    dSave: function() {
      return this.busy || this.disableSave || !this.save
    },
    dNext: function() {
      return this.busy || !this.next;
    }
  },
  methods: {
    listingSaveEvent: function() {
      this.$emit('save');
      this.animateSubmitButton = this.savingAnimation;
      this.enableSubmitAnimation(true);
    }
  }
}
</script>

<style scoped lang="scss">
.btn-fixed {
  @media only screen and (min-width: 375px) {
    min-width: 100px;
  }

  @media only screen and (max-width: 374px) {
    min-width: 90px;
  }

  @include media-breakpoint-down(sm) {
    height: 40px;
  }
}

.animated-submit {
  &.animate {
    margin: 5px 0;
  }
}
</style>
